import React from "react";
import MomentoConciencia from "@/components/MomentoConciencia";

export const BLOG_TIEMPO = "https://olimpo.tech/blog/que-hago-con-mi-tiempo";

// Pop-up de una sola vez, con el mismo tono y tipeo que los Momentos de conciencia.
// El botón principal abre la nota en pestaña nueva; "saltear" solo cierra. En ambos casos se marca visto.
const MOMENTO_TIEMPO = {
  id: "tiempo",
  boton: "Leer la nota",
  parrafos: [
    "{Nombre}, pará un segundo.",
    "Acabás de poner a andar tu tercer proceso. La parte difícil ya está hecha.",
    "Lo que recuperaste no es una idea: son horas reales, las que antes se te iban en tareas que no necesitaban tu cabeza.",
    "[[Y acá empieza la parte que casi nadie hace.]]",
    "Lo que sigue no es automatizar más. Es decidir en qué vas a usar ese tiempo — antes de que se llene solo de más de lo mismo.",
    "Por eso abrimos una sección nueva. Para que ese tiempo no se te escurra sin que lo elijas vos.",
    "Te dejamos algo escrito para pensarlo con calma.",
  ],
};

export default function PopupTiempo({ nombre, empresa, onCerrar }) {
  const cerrar = ({ salteado }) => {
    if (!salteado) window.open(BLOG_TIEMPO, "_blank", "noopener,noreferrer");
    onCerrar();
  };
  return <MomentoConciencia momento={MOMENTO_TIEMPO} vars={{ nombre, empresa }} onCerrar={cerrar} />;
}
